import React from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";

import MissingRecordModal from "./MissingRecordModal";
import BeefProductPicker from "./BeefProductPicker";
import GatewayExistsAlert from "./GatewayExistsAlert";
import GatewayRequestDebugPanel from "./GatewayRequestDebugPanel";
import MissingRetailerField from "./MissingRetailerField";
import { buildGatewayAdminRecordUrl } from "../../../services/missingReports";

const BarcodeMissingSelectedModal = ({
  selected,
  taskRun,
  actionLoading,
  error,
  loadingTaskRun,
  onClose,
  onResolve,
  onSkip,
  onReject,
  resolveDisabled,
  skipDisabled,
  retailerId,
  retailerName,
  retailerMode,
  onRetailerModeChange,
  onRetailerNameChange,
  onRetailerIdChange,
  suggestedRetailerId,
  suggestedRetailerName,
  retailerResolutionSource,
  hasRetailerRefId,
  exactRetailerMatchFound,
  beefProductId,
  onBeefProductChange,
  barcodeCode,
  onBarcodeCodeChange,
  gatewayBarcodeStatus,
  resolveRequestPreview,
}) => (
  <MissingRecordModal
    open={Boolean(selected)}
    title="Barcode missing record"
    record={selected}
    taskRun={taskRun}
    actionLoading={actionLoading}
    error={error}
    onClose={onClose}
    onResolve={onResolve}
    onSkip={onSkip}
    onReject={onReject}
    resolveDisabled={resolveDisabled}
    skipDisabled={skipDisabled}
  >
    <Box>
      <GatewayExistsAlert
        checking={Boolean(gatewayBarcodeStatus?.checking)}
        exists={Boolean(gatewayBarcodeStatus?.exists)}
        url={
          gatewayBarcodeStatus?.id
            ? buildGatewayAdminRecordUrl("barcode", gatewayBarcodeStatus.id)
            : ""
        }
        label="barcode"
      />
      {loadingTaskRun ? (
        <Typography variant="body2" color="text.secondary">
          Loading record details...
        </Typography>
      ) : null}
      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
        {selected?.product_name || "Unknown product"}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Normalized: {selected?.normalized_product_name || "Not provided"}
      </Typography>
      <Table size="small" sx={{ mt: 2, border: "1px solid #e0e0e0" }}>
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: "30%", fontWeight: 600 }}>Field</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Value</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Barcode</TableCell>
            <TableCell>
              <TextField
                size="small"
                fullWidth
                label="Barcode"
                value={barcodeCode}
                onChange={(event) => onBarcodeCodeChange(event.target.value)}
                helperText="Edit if the scanned code needs correction before resolving."
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Retailer</TableCell>
            <TableCell>
              <MissingRetailerField
                retailerLabel={selected?.retailer}
                retailerId={retailerId}
                retailerMode={retailerMode}
                onRetailerModeChange={onRetailerModeChange}
                retailerName={retailerName}
                onRetailerNameChange={onRetailerNameChange}
                onRetailerIdChange={onRetailerIdChange}
                suggestedRetailerId={suggestedRetailerId}
                suggestedRetailerName={suggestedRetailerName}
                retailerResolutionSource={retailerResolutionSource}
                hasRetailerRefId={hasRetailerRefId}
                exactRetailerMatchFound={exactRetailerMatchFound}
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Beef product</TableCell>
            <TableCell>
              <BeefProductPicker
                selectedId={beefProductId}
                onSelectedIdChange={onBeefProductChange}
                seedTerms={[selected?.product_name, selected?.normalized_product_name]}
              />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <GatewayRequestDebugPanel
        title="Gateway debug request preview (Barcode Missing)"
        request={resolveRequestPreview}
      />
    </Box>
  </MissingRecordModal>
);

export default BarcodeMissingSelectedModal;
